const isChina = process.env.EXT_SHORT === "cn";

export const termsLink = (isChinaLang: boolean): string => {
  return isChina || isChinaLang
    ? "https://vitalerter.cn/service"
    : "https://vitalerter.com/terms";
};

export const privacyLink = (isChinaLang: boolean): string => {
  return isChina || isChinaLang
    ? "https://vitalerter.cn/privacy"
    : "https://vitalerter.com/privacy";
};

export const googlePlayLink = (): string => {
  return "https://play.google.com/store/apps/details?id=com.vitalerter";
};

export const googlePlayLinkApp = (): string => {
  // return 'market://details?id=com.vitalerter';
  return "intent://open.vitalerter/#Intent;scheme=app;package=com.vitalerter;end";
};

export const googlePlayLinkAppToken = (token: string): string => {
  // return 'market://details?id=com.vitalerter';
  return `intent://open.vitalerter/auth?token=${token}/#Intent;scheme=app;package=com.vitalerter;end`;
};

export const appStoreLink = (): string => {
  return "itms-apps://itunes.apple.com/app/vitalerter/id1274397555";
};

export const appStoreLinkApp = (): string => {
  return "open.vitalerter://open.vitalerter";
};

export const appStoreLinkAppToken = (token: string): string => {
  return `open.vitalerter://open.vitalerter/auth?token=${token}`;
};

export const validateEmail = (email: string): boolean => {
  if (!email) return false;
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
export const validatePhone = (value: string): boolean => {
  const re = /^\+\d{9,14}$/;
  return re.test(value);
};
export const validate = (username: string): boolean => {
  return validatePhone(username) || validateEmail(username);
};
